export default "__VITE_ASSET__CM54Rlin__"